import { render } from "./ProgrammingTech.vue?vue&type=template&id=be361d60&scoped=true"
import script from "./ProgrammingTech.vue?vue&type=script&lang=js"
export * from "./ProgrammingTech.vue?vue&type=script&lang=js"

import "./ProgrammingTech.vue?vue&type=style&index=0&id=be361d60&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be361d60"]])

export default __exports__